export default __webpack_public_path__ + "static/media/f_md-12.af680435.svg";